<template>
  <!-- Video overlay -->
  <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-40 px-4 md:px-12 lg:px-20 py-20 transition-opacity duration-200"
       :class="{ 'visible opacity-100 pointer-events-auto': showOverlay && videoUrl, 'invisible opacity-0 pointer-events-none': !showOverlay || !videoUrl }"
  >
    <div ref="overlay" class="w-full max-w-6xl">
      <div v-if="showOverlay && videoUrl" class="video-container">
        <youtube-video :video-id="videoUrl" />
      </div>
    </div>

    <button class="absolute top-0 ltr:right-0 rtl:left-0 transform ltr:-translate-x-4 rtl:translate-x-4 translate-y-4 ltr:md:-translate-x-12 rtl:md:translate-x-12 md:translate-y-12 w-16 h-16 flex bg-white items-center justify-center rounded-full shadow focus:outline-none"
            @click="onCloseOverlay($event)"
    >
      <span class="icon-close text-blue-dark" />
    </button>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import YoutubeVideo from '@/components/YoutubeVideo.vue'
import EventBus from '../event-bus'

export default {
  components: { YoutubeVideo },
  data() {
    return {
      videoUrl: '',
      showOverlay: false
    }
  },
  mounted() {
    EventBus.$on('SHOW_VIDEO_OVERLAY', (videoUrl) => {
      this.videoUrl = videoUrl
      this.showOverlay = true
      disableBodyScroll(this.$refs.overlay)
    })
  },
  methods: {
    onCloseOverlay(e) {
      e.preventDefault()
      enableBodyScroll(this.$refs.overlay)
      this.videoUrl = ''
      this.showOverlay = false
    }
  }
}
</script>

<style>
  .video-container {
    @apply relative h-0 overflow-hidden max-w-full pb-9/16;
  }

  .video-container iframe,
  .video-container object,
  .video-container embed {
    @apply absolute top-0 left-0 w-full h-full;
  }
</style>
